import { defineStore } from 'pinia';
import { LoadingStates } from '../enums/LoadingStates';
import { getWithMetrics } from '../util/fetchWithMetrics';

export const useLanguagesStore = defineStore('languages', {
    state: () => ({
        loadingState: LoadingStates.notLoaded,
        errorMessage: '',
        languages: [],
    }),
    getters: {
        localeCodes() {
            return this.languages.map((language) => language.code);
        },
    },
    actions: {
        async loadLanguages() {
            if (this.loadingState !== LoadingStates.notLoaded) {
                return;
            }
            this.loadingState = LoadingStates.loading;
            try {
                const output = await getWithMetrics('/trim-metadata/languages', {}, (payload) =>
                    Array.isArray(payload.languages)
                );
                this.languages = output.languages;
                this.loadingState = LoadingStates.loaded;
            } catch (error) {
                this.errorMessage = `Error encountered while fetching languages: [${error}]`;
                this.loadingState = LoadingStates.error;
            }
        },
    },
});
